import styled from 'styled-components';

import StaticPageLayout from '../../components/Container/StaticPageLayout';

const FreeConsultationPage = () => {
  return (
    <StaticPageLayout>
      <Title>無料相談会のご案内</Title>
      <Content>
        <p>Ez-AiOCRに関するご相談にオンラインでお答えします。</p>
        <p>機能や操作方法のご質問、ご意見・ご要望などございましたら、お聞かせください。</p>
        <p>以下のURLからご都合のいい日程を選択いただけますと幸いです。</p>
        <a href="https://booking.receptionist.jp/ezaiocr_support/30min">
          https://booking.receptionist.jp/ezaiocr_support/30min
        </a>
      </Content>
    </StaticPageLayout>
  );
};

export default FreeConsultationPage;

const Title = styled.h1`
  color: #8da9db;
  font-weight: 600;
  margin-bottom: 24px;
`;

const Content = styled.div`
  width: 800px;
  padding: 0 48px;
`;
